import { render, staticRenderFns } from "./PostListTable.vue?vue&type=template&id=54c6ef24&scoped=true"
import script from "./PostListTable.vue?vue&type=script&lang=js"
export * from "./PostListTable.vue?vue&type=script&lang=js"
import style0 from "./PostListTable.vue?vue&type=style&index=0&id=54c6ef24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c6ef24",
  null
  
)

export default component.exports